/* Jamal Al Muhra — gift options (cart drawer + PDP "Send as a Gift").
   Delegated listeners: survive drawer re-renders via innerHTML. */
(function () {
  var msgTimer;

  function postAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-jam-gift-toggle]')) return;
    var wrap = el.closest('[data-jam-gift]');
    var msg = wrap && wrap.querySelector('.jam-gift__msg');
    if (msg) msg.hidden = !el.checked;
    var ta = wrap && wrap.querySelector('[data-jam-gift-msg]');
    postAttributes({
      'Gift Card': el.checked ? 'Yes' : '',
      'Gift Card Message': el.checked && ta ? ta.value : ''
    });
  });

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-jam-gift-msg]')) return;
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () {
      postAttributes({ 'Gift Card Message': el.value });
    }, 600);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jam-gift-cta]');
    if (!btn) return;
    var buttons = btn.closest('.product-form__buttons');
    var submit = buttons && buttons.querySelector('.product-form__submit');
    if (!submit || submit.disabled) return;
    submit.click();
    // after the theme's add-to-cart flow re-renders the drawer, mark the order as a gift
    setTimeout(function () {
      postAttributes({ 'Gift Card': 'Yes' }).then(function () {
        var box = document.querySelector('[data-jam-gift-toggle]');
        if (!box) return;
        box.checked = true;
        var wrap = box.closest('[data-jam-gift]');
        var msg = wrap && wrap.querySelector('.jam-gift__msg');
        if (msg) msg.hidden = false;
        var ta = wrap && wrap.querySelector('[data-jam-gift-msg]');
        if (ta) setTimeout(function () { try { ta.focus(); } catch (_) {} }, 300);
      });
    }, 900);
  });
})();

/* header cart icon: visible only when the cart holds something */
(function () {
  var queued = false;
  function syncCartHead() {
    document.querySelectorAll('[data-jam-cart-head]').forEach(function (head) {
      var count = head.querySelector('.wbhcartitem');
      if (!count) return;
      var n = parseInt(count.textContent, 10) || 0;
      count.classList.toggle('jam-badge-zero', n === 0);
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; syncCartHead(); });
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('DOMContentLoaded', syncCartHead);
})();

/* back/forward cache: re-sync the cart badge when a page is restored */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-jam-cart-head] .wbhcartitem').forEach(function (count) {
        count.textContent = cart.item_count;
        count.classList.toggle('jam-badge-zero', cart.item_count === 0);
      });
    })
    .catch(function () {});
});

/* language pill: keep query params (?view=wishlist, filters) when switching language */
document.addEventListener('click', function (e) {
  var pill = e.target.closest && e.target.closest('.jam-lang');
  if (!pill || !location.search) return;
  e.preventDefault();
  window.location.href = pill.getAttribute('href') + location.search;
});

/* Dirham symbol: replace the AED text inside span.jam-dhs (from the money
   format) with U+20C3 once the glyph font is confirmed loaded; observe the
   DOM so drawer/variant re-renders get swapped too. */
(function () {
  var ready = false;
  function swap(root) {
    if (!ready) return;
    (root || document).querySelectorAll('.jam-dhs').forEach(function (el) {
      if (el.textContent !== '\u20C3') el.textContent = '\u20C3';
    });
  }
  function arm() {
    ready = true;
    swap();
    new MutationObserver(function () { swap(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.fonts && document.fonts.load) {
    var armWhenReady = function () {
      if (document.readyState !== 'loading') arm();
      else document.addEventListener('DOMContentLoaded', arm);
    };
    var tryArm = function () {
      if (document.fonts.check('1em DirhamSign', '\u20C3')) { armWhenReady(); return true; }
      return false;
    };
    document.fonts.load('1em DirhamSign', '\u20C3').then(function () {
      if (!tryArm()) setTimeout(tryArm, 1500);
    }).catch(function () {});
  }
})();

/* v76: grand logo on open (mobile). Sharp rendition + html.jam-top toggle with
   hysteresis so the boundary never jitters. CSS does the rest (jam-polish v76). */
(function () {
  var ml = document.querySelector('.header__heading-mobile-logo');
  if (ml) {
    ml.removeAttribute('srcset');
    ml.removeAttribute('sizes');
    if (/width=\d+/.test(ml.src)) ml.src = ml.src.replace(/width=\d+/, 'width=240');
  }
  var doc = document.documentElement;
  function onScroll() {
    var y = window.scrollY || 0;
    if (y < 30) doc.classList.add('jam-top');
    else if (y > 70) doc.classList.remove('jam-top');
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
